var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '../Button';
import styled from 'styled-components';
var StyledDialogActions = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: left;\n  position: absolute;\n  width: 100%;\n  margin-left: 2rem;\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n"], ["\n  align-items: left;\n  position: absolute;\n  width: 100%;\n  margin-left: 2rem;\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n"])));
var StyledButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: black;\n  background-color: white;\n  text-decoration: underline;\n  margin-left: .5rem;\n  &:hover {\n    background-color: white;\n    border-color: white;\n    cursor: pointer;\n  }\n"], ["\n  color: black;\n  background-color: white;\n  text-decoration: underline;\n  margin-left: .5rem;\n  &:hover {\n    background-color: white;\n    border-color: white;\n    cursor: pointer;\n  }\n"])));
var DialogActions = function (props) {
    return _jsxs(StyledDialogActions, { children: [_jsx(Button, { text: props.submitText, onClick: props.onSubmit }), _jsx(StyledButton, __assign({ onClick: props.onCancel }, { children: props.cancelText }))] });
};
export default DialogActions;
var templateObject_1, templateObject_2;
